import { sendGet, sendPost } from "./generic"

// export const getUsers = () => {
//     return sendGet(`Admin/Agencies`)
// }

export const addContact = (payload) => {
    return sendPost(`Admin/Contacts`, payload)
}

export const editContact = (payload) => {
    return sendPost(`Admin/Contacts`, payload)
}

export const inviteContact = (id) => {
    return sendGet(`Admin/Contacts/${id}/Invite`)
}

export const switchAgency = (payload) => {
    return sendPost(`Admin/Contacts/Switch`, payload)
}

export const getContact = (id) => {
    return sendGet(`Admin/Contacts/${id}`)
}
